export default "__VITE_ASSET__D3La7ikR__"